/**
 * @author Fido García <garciafido@gmail.com>
 */
export const nullToUndefined = <T>(x: T): Exclude<T, null> | undefined => x === null ? undefined : (x as Exclude<T, null>);
